module.exports = __webpack_public_path__ + "img/gg-1.fa6a9f24.png";